import { AuthReducerModal } from "../../store/slices/initialState";
import services from "../../Constant/service";
import endpoint from "../../Constant/endpoint";
import {
  createSlice,
  createAsyncThunk,
  isPending,
  isFulfilled,
  isRejected,
} from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "../../store/slices/loaderSlice";
const initialState = new AuthReducerModal();

const adminSlice = createSlice({
  name: "adminSlice",
  initialState,
  reducers: {
    set: (state, action) => ({ ...state, ...action.payload }),
    loader: (state, action) => ({ ...state, isLoader: action.payload }),
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(isPending, (state) => ({ ...state, isLoader: true }))
      .addMatcher(isFulfilled, (state, action) => {
        const actionName = action.type.split("/")[1];
        const dynamicKey = `${actionName}Response`;
        return {
          ...state,
          isLoader: false,
          [dynamicKey]: action.payload,
        };
      })
      .addMatcher(isRejected, (state) => ({ ...state, isLoader: false }));
  },
});

export const addAgeGroup = createAsyncThunk(
  "ageGroup/addAgeGroup",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.admin.addAgeGroup,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const getAgeGroupList = createAsyncThunk(
  "admin/getAgeGroupList",
  async (
    {
      callback,
      errorCallback,
    }: { callback: (data: any) => void; errorCallback: (error?: any) => void },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getAgeGroupList,
        "",
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const addProductType = createAsyncThunk(
  "ageGroup/addProductType",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.admin.addProductType,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateAgeGroup = createAsyncThunk(
  "admin/updateAgeGroup",
  async (
    {
      id,
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.patchApiCall(
        endpoint.admin.updateAgeGroup + id,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const deleteAgeGroup = createAsyncThunk(
  "admin/deleteAgeGroup",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.deleteApiCall(
        endpoint.admin.deleteAgeGroup + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

// ****************Product Type****************

export const getProductTypeList = createAsyncThunk(
  "admin/getProductTypeList",
  async (
    {
      callback,
      errorCallback,
    }: { callback: (data: any) => void; errorCallback: (error?: any) => void },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getProductTypeList,
        "",
        (res: any) => {
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateProductType = createAsyncThunk(
  "admin/updateProductType",
  async (
    {
      id,
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.patchApiCall(
        endpoint.admin.updateProductType + id,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteProductType = createAsyncThunk(
  "admin/deleteProductType",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.deleteApiCall(
        endpoint.admin.deleteProductType + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
// ******************Category****************

export const addCategory = createAsyncThunk(
  "admin/addCategory",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.admin.addCategory,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getCategoryList = createAsyncThunk(
  "admin/getCategoryList",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.admin.getCategoryList,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateCategory = createAsyncThunk(
  "admin/updateCategory",
  async (
    {
      id,
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.patchApiCall(
        endpoint.admin.updateCategory + id,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteCategory = createAsyncThunk(
  "admin/deleteCategory",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.deleteApiCall(
        endpoint.admin.deleteCategory + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

// ******************SubCategory****************
export const addSubCategory = createAsyncThunk(
  "admin/addSubCategory",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.admin.addSubCategory,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getSubCategoryList = createAsyncThunk(
  "admin/getSubCategoryList",
  async (
    {
      callback,
      errorCallback,
    }: { callback: (data: any) => void; errorCallback: (error?: any) => void },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getSubCategoryList,
        "",
        (res: any) => {
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
// ***************Category Video**************
export const uploadCategoryVideo = createAsyncThunk(
  'admin/uploadCategoryVideo',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    dispatch(showLoader());
    try {
      dispatch(set({ isLoader: true }));
      let formData = new FormData();
      formData.append("file", params);
      await services.postUploadMedia(
        endpoint.admin.uploadCategoryVideo,
        formData,
        (res: any) => {
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            dispatch(hideLoader());
            return res;
          } else {
            errorCallback(res);
            dispatch(hideLoader());
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(hideLoader());
          errorCallback(error);
          return rejectWithValue(error.message);
        },
      );
    } catch (error: any) {
      dispatch(hideLoader());
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const addCategoryVideo = createAsyncThunk(
  "admin/addCategoryVideo",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(showLoader());
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.admin.addCategoryVideo,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            dispatch(hideLoader());
            return res;
          } else {
            errorCallback(res);
            dispatch(hideLoader());
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          dispatch(hideLoader());
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      dispatch(hideLoader());
      return rejectWithValue(error.message);
    }
  }
);
export const updateCategoryVideo = createAsyncThunk(
  "admin/updateCategoryVideo",
  async (
    {
      id,
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.patchApiCall(
        endpoint.admin.updateCategoryVideo + id,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res?.data);
            return res?.data;
          } else {
            errorCallback(res?.data);
            return rejectWithValue(res?.data?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const getCategoryVideoListById = createAsyncThunk(
  "admin/getCategoryVideoListById",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getCategoryVideoListById + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res?.data);
            return res?.data;
          } else {
            errorCallback(res?.data);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const getCategoryVideoById = createAsyncThunk(
  "admin/getCategoryVideoById",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getCategoryVideoById + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res?.data);
            return res?.data;
          } else {
            errorCallback(res?.data);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => { }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const deleteCategoryVideo = createAsyncThunk(
  "admin/deleteCategoryVideo",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.deleteApiCall(
        endpoint.admin.deleteCategoryVideo + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
// ******************TagOption****************

export const addTagOption = createAsyncThunk(
  "admin/addTagOption",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.admin.addTagOption,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateTagOption = createAsyncThunk(
  "admin/updateTagOption",
  async (
    {
      id,
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.patchApiCall(
        endpoint.admin.updateTagOption + id,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteTagOption = createAsyncThunk(
  "admin/deleteTagOption",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.deleteApiCall(
        endpoint.admin.deleteTagOption + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getTagOptionList = createAsyncThunk(
  "admin/getTagOptionList",
  async (
    {
      callback,
      errorCallback,
    }: { callback: (data: any) => void; errorCallback: (error?: any) => void },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getTagOptionList,
        "",
        (res: any) => {
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
// ******************Product****************
export const addProduct = createAsyncThunk(
  "admin/addProduct",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.admin.addProduct,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const getLanguageList = createAsyncThunk(
  "admin/getLanguageList",
  async (
    {
      callback,
      errorCallback,
    }: { callback: (data: any) => void; errorCallback: (error?: any) => void },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getLanguageList,
        "",
        (res: any) => {
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getProductList = createAsyncThunk(
  "admin/getProductList",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.admin.getProductList,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getProductById = createAsyncThunk(
  "admin/getProductById",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getProductById + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "admin/deleteProduct",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.deleteApiCall(
        endpoint.admin.deleteProduct + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getGSTList = createAsyncThunk(
  "/v1/general/GSTPercentage",
  async (
    {
      callback,
      errorCallback,
    }: { callback: (data: any) => void; errorCallback: (error?: any) => void },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getGSTList,
        "",
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateProduct = createAsyncThunk(
  "admin/updateProduct",
  async (
    {
      id,
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.patchApiCall(
        endpoint.admin.updateProduct + id,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

// ******************Blog****************
export const addBlog = createAsyncThunk(
  "admin/addBlog",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.admin.addBlog,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getBlogList = createAsyncThunk(
  "admin/getBlogList",
  async (
    {
      callback,
      errorCallback,
    }: { callback: (data: any) => void; errorCallback: (error?: any) => void },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getBlogList,
        "",
        (res: any) => {
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateBlog = createAsyncThunk(
  "admin/updateBlog",
  async (
    {
      id,
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.patchApiCall(
        endpoint.admin.updateBlog + id,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getBlogDetailsById = createAsyncThunk(
  "admin/getBlogDetailsById",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getBlogDetailsById + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            callback(res?.data);
            return res?.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteBlog = createAsyncThunk(
  "admin/deleteBlog",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.deleteApiCall(
        endpoint.admin.deleteBlog + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

// ***************************************

export const getGeneralProductType = createAsyncThunk(
  "admin/getProductTypeList",
  async (
    {
      callback,
      errorCallback,
    }: { callback: (data: any) => void; errorCallback: (error?: any) => void },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getGeneralProductType,
        "",
        (res: any) => {
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

/*******************************Base Offer**************************************/
export const addBaseOffer = createAsyncThunk(
  "admin/addBaseOffer",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.admin.addBaseOffer,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getBaseOfferList = createAsyncThunk(
  "admin/getProductTypeList",
  async (
    {
      callback,
      errorCallback,
    }: { callback: (data: any) => void; errorCallback: (error?: any) => void },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getBaseOfferList,
        "",
        (res: any) => {
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getBaseOfferById = createAsyncThunk(
  "admin/getBaseOfferById",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getBaseOfferById + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res?.data);
            return res?.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateBaseOffer = createAsyncThunk(
  "admin/updateBaseOffer",
  async (
    {
      id,
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.patchApiCall(
        endpoint.admin.updateBaseOffer + id,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteBaseOffer = createAsyncThunk(
  "admin/deleteBaseOffer",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.deleteApiCall(
        endpoint.admin.deleteBaseOffer + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

// ***********************************CouponCode**********************
export const getCouponType = createAsyncThunk(
  "admin/getCouponType",
  async (
    {
      callback,
      errorCallback,
    }: { callback: (data: any) => void; errorCallback: (error?: any) => void },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getCouponType,
        "",
        (res: any) => {
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const createCouponCode = createAsyncThunk(
  "admin/createCouponCode",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.admin.createCouponCode,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getCouponCodeList = createAsyncThunk(
  "admin/getCouponCodeList",
  async (
    {
      callback,
      errorCallback,
    }: { callback: (data: any) => void; errorCallback: (error?: any) => void },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getCouponCodeList,
        "",
        (res: any) => {
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getCouponCodeById = createAsyncThunk(
  "admin/getCouponCodeById",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getCouponCodeById + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res?.data);
            return res?.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateCouponCode = createAsyncThunk(
  "admin/updateCouponCode",
  async (
    {
      id,
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.patchApiCall(
        endpoint.admin.updateCouponCode + id,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteCouponCode = createAsyncThunk(
  "admin/deleteCouponCode",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.deleteApiCall(
        endpoint.admin.deleteCouponCode + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

// ***********************************Author**********************
export const createAuthor = createAsyncThunk(
  "admin/createAuthor",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.admin.createAuthor,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getAuthorList = createAsyncThunk(
  "admin/getAuthorList",
  async (
    {
      callback,
      errorCallback,
    }: { callback: (data: any) => void; errorCallback: (error?: any) => void },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getAuthorList,
        "",
        (res: any) => {
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getAuthorDetailsById = createAsyncThunk(
  "admin/getAuthorDetailsById",
  async (
    {
      UniqueName,
      callback,
      errorCallback,
    }: {
      UniqueName: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getAuthorDetailsById + UniqueName,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res?.data);
            return res?.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateAuthor = createAsyncThunk(
  "admin/updateAuthor",
  async (
    {
      id,
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.patchApiCall(
        endpoint.admin.updateAuthor + id,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.status === services?.status_code?.success) {
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteAuthor = createAsyncThunk(
  "admin/deleteAuthor",
  async (
    {
      id,
      callback,
      errorCallback,
    }: {
      id: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.deleteApiCall(
        endpoint.admin.deleteAuthor + id,
        "",
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

// ***********************************User**********************
export const getRoleList = createAsyncThunk(
  "admin/getRoleList",
  async (
    {
      callback,
      errorCallback,
    }: { callback: (data: any) => void; errorCallback: (error?: any) => void },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getRoleList,
        "",
        (res: any) => {
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createUser = createAsyncThunk(
  "admin/createUser",
  async (
    {
      params,
      callback,
      errorCallback,
    }: {
      params: any;
      callback: (data: any) => void;
      errorCallback: (error?: any) => void;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.postApiCall(
        endpoint.admin.createUser,
        params,
        (res: any) => {
          dispatch(set({ isLoader: true }));
          if (res?.statusCode === services?.status_code?.success) {
            // services.setAuthorizationToken(res.data.token.access.token);
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const getSellingSource = createAsyncThunk(
  "admin/getSellingSource",
  async (
    {
      callback,
      errorCallback,
    }: { callback: (data: any) => void; errorCallback: (error?: any) => void },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.admin.getSellingSource,
        "",
        (res: any) => {
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);


export const uploadAgeGroupImage = createAsyncThunk(
  'admin/uploadAgeGroupImage',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      let formData = new FormData();
      formData.append("file", params);
      await services.postUploadMedia(
        endpoint.admin.uploadAgeGroupImage,
        formData,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.statusCode === services?.status_code?.success) {

            callback(res);
            return res;
          } else {

            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const uploadProductTypeImage = createAsyncThunk(
  'admin/uploadProductTypeImage',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      let formData = new FormData();
      formData.append("file", params);
      await services.postUploadMedia(
        endpoint.admin.uploadProductTypeImage,
        formData,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.statusCode === services?.status_code?.success) {

            callback(res);
            return res;
          } else {

            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const uploadCategoryImage = createAsyncThunk(
  'admin/uploadCategoryImage',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      let formData = new FormData();
      formData.append("file", params);
      await services.postUploadMedia(
        endpoint.admin.uploadCategoryImage,
        formData,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.statusCode === services?.status_code?.success) {

            callback(res);
            return res;
          } else {

            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const uploadAutorImage = createAsyncThunk(
  'admin/uploadAutorImage',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      let formData = new FormData();
      formData.append("file", params);
      await services.postUploadMedia(
        endpoint.admin.uploadAutorImage,
        formData,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.statusCode === services?.status_code?.success) {

            callback(res);
            return res;
          } else {

            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const uploadBlogImage = createAsyncThunk(
  'admin/uploadBlogImage',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(set({ isLoader: true }));
      let formData = new FormData();
      formData.append("file", params);
      await services.postUploadMedia(
        endpoint.admin.uploadBlogImage,
        formData,
        (res: any) => {
          dispatch(set({ isLoader: false }));
          if (res?.statusCode === services?.status_code?.success) {

            callback(res);
            return res;
          } else {

            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(set({ isLoader: false }));
          errorCallback(error);
          return rejectWithValue(error.message);
        },
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const uploadMedia = createAsyncThunk(
  'admin/uploadMedia',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    dispatch(showLoader());
    try {
      let formData = new FormData();
      formData.append("file", params?.file);
      formData.append("type", params?.type);
      formData.append("format", params?.format);
      await services.postUploadMedia(
        endpoint.admin.uploadMedia,
        formData,
        (res: any) => {
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            dispatch(hideLoader());
            return res;
          } else {
            errorCallback(res);
            dispatch(hideLoader());
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(hideLoader());
          errorCallback(error);
          return rejectWithValue(error.message);
        },
      );
    } catch (error: any) {
      dispatch(hideLoader());
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const booksAnswerkeyUpload = createAsyncThunk(
  'admin/booksAnswerkeyUpload',
  async ({ params, callback, errorCallback }: { params: any, callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    dispatch(showLoader());
    try {
      let formData = new FormData();
      formData.append("file", params);
      await services.postUploadMedia(
        endpoint.admin.booksAnswerkeyUpload,
        formData,
        (res: any) => {
          if (res?.statusCode === services?.status_code?.success) {
            callback(res);
            dispatch(hideLoader());
            return res;
          } else {
            errorCallback(res);
            dispatch(hideLoader());
            return rejectWithValue(res?.msg);
          }
        },
        (error: any) => {
          dispatch(hideLoader());
          errorCallback(error);
          return rejectWithValue(error.message);
        },
      );
    } catch (error: any) {
      dispatch(hideLoader());
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const { set, loader, reset } = adminSlice.actions;
export default adminSlice.reducer;
